<section class="heros">
    <div class="container">
        <article class="d-flex align-items-center justify-content-center">
            <h1 class="c-title c-title-not-connected c-title-contrast rounded p-3 flex-grow-1 text-center"
                translate="hors-connexion.titre"></h1>
        </article>
    </div>
</section>

<section class="services">
    <div class="container">
        <div class="card d-md-none">
            <div class="card-body">
                <div class="d-flex flex-column align-items-center">
                    <h2 class="c-card-title" translate="hors-connexion.texte.pour-se-connecter"></h2>
                    <button class="fr-connect" type="button"
                            (click)="connectionToFC('')">
                        <span class="fr-connect__login" translate="global.menu.france-connect-identify"></span>
                        <span class="fr-connect__brand" translate="global.menu.france-connect"></span>
                    </button>
                </div>
                <div class="d-flex justify-content-center pb-2">
                    <a class="navbar-france-connect france-connect-link d-md-none"
                       href="https://app.franceconnect.gouv.fr/en-savoir-plus"
                       translate="global.menu.france-connect-help" target="_blank" rel="noopener noreferrer"
                       [title]="'global.menu.france-connect-title' | translate">
                    </a>
                </div>

            </div>
        </div>

        <h2 class="c-title c-title-services text-center pb-4 pt-2 my-3"
            translate="hors-connexion.services.presentation"></h2>

        <div class="row align-items-stretch">
            <div class="col-12 col-md-6 col-lg-3 mb-4">
                <div class="card rounded h-100">
                    <div class="card-body">
                        <h3 class="c-card-title mb-1"
                            translate="hors-connexion.services.demande-permis.titre"></h3>
                        <ned-icon type="pv-color" class="d-flex justify-content-center mx-auto my-3" [width]="120"></ned-icon>
                        <p class="c-card-text mt-2" translate="hors-connexion.services.demande-permis.demande"></p>
                        <p class="c-card-text mt-4" translate="hors-connexion.acces-service"
                           [translateParams]="{'nomService': allocationNomService('permisVisite') || 'null' }"></p>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-6 col-lg-3 mb-4">
                <div class="card h-100">
                    <div class="card-body">
                        <h3 class="c-card-title mb-1"
                            translate="hors-connexion.services.parloir.titre"></h3>
                        <ned-icon type="calendar-color" class="d-flex justify-content-center mx-auto my-3" [width]="120"></ned-icon>
                        <p class="c-card-text mt-2" translate="hors-connexion.services.parloir.texte"></p>
                        <p class="c-card-text mt-4" translate="hors-connexion.acces-service"
                           [translateParams]="{'nomService': allocationNomService('parloirs') || 'null' }"></p>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-6 col-lg-3 mb-4">
                <div class="card h-100">
                    <div class="card-body">
                        <h3 class="c-card-title mb-1"
                            translate="hors-connexion.services.pecule.titre"></h3>
                        <ned-icon type="payment-card-color" class="d-flex justify-content-center mx-auto my-3" [width]="120"></ned-icon>
                        <p class="c-card-text mt-2" translate="hors-connexion.services.pecule.texte"></p>
                        <p class="c-card-text mt-4" translate="hors-connexion.acces-service"
                           [translateParams]="{'nomService': allocationNomService('pecule') || 'null' }"></p>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-6 col-lg-3 mb-4">
                <div class="card h-100">
                    <div class="card-body">
                        <h3 class="c-card-title card-title mb-1"
                            translate="hors-connexion.services.faq.titre"></h3>
                        <ned-icon type="faq-color" class="d-flex justify-content-center mx-auto my-3" [width]="120"></ned-icon>
                        <p class="c-card-text my-2" translate="hors-connexion.services.faq.texte"></p>

                        <div class="d-flex justify-content-center mt-1">
                            <a class="btn c-btn c-btn-ocean"
                                    [routerLink]="['/communication/faq']"
                                    translate="hors-connexion.services.faq.bouton"
                                    attr.aria-label="{{'hors-connexion.services.faq.consulter-faq' | translate}}">
                            </a>
                        </div>

                    </div>
                </div>
            </div>

        </div>

    </div>
</section>
